const initState = {
  transactionTable: [],
  previousTable: [],
  contToken: [],
};

const transactionTableReducer = (state = initState, action) => {
  switch (action.type) {
    case "TRANS_TABLE_FETCH":
      return {
        ...state,
        transactionTable: action.payload,
      };
    case "TRANS_TABLE_PREV":
      return {
        ...state,
        previousTable: action.payload,
      };
    case "TRANS_TABLE_CONT_TOKEN":
      return {
        ...state,
        contToken: action.payload,
      };
    default:
      return state;
  }
};

export default transactionTableReducer;
